import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import WorkFlowPlanCriteriaRow from './WorkFlowPlanCriteriaRow';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormROValue from '../../../../library/form/components/FormROValue1';
import FormDialog from '../../../../library/form/components/FormDialog';
import { UiViewContent } from "../../../../library/layout/Index";

const WorkFlowPlanCriteriaEditor = (props) => {
    const { formObject, viewData, ...restProps } = props;

    if (!viewData)
        return (null)
    else {
        return (
            <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true}
                action={{ formActions: { forClose: "Close" } }}
                formStyle={{ width: '670px' }}
                contentStyle={{ height: '300px' }}
                formTitle={<FormTitle formObject={formObject} value='Condition Detail' />}
                formObject={formObject} >
                <div className="phViewHeading">
                    <div className="phTitle">
                        <FormROValue format="#" formObject={formObject} headerKey="wfCriteria" action={{ paramName: "activityId" }} className='uiVal' />
                        <FormROValue format="#" formObject={formObject} headerKey="wfCriteria" action={{ paramName: "activityName" }} className='uiVal' />
                    </div>
                </div>
                <UiViewContent>
                    <ul className="uiListTable">
                        <li className="uiSearchHeading">
                            <ul>
                                <li className="uiColumn uiColumn150"><SarasTrans value="Condition Type" /></li>
                                <li className="uiColumn uiColumn150"><SarasTrans value="Condition" /></li>
                            </ul>
                        </li>
                        {
                            Object.values(viewData).map((row, index) => (
                                <li className="uiSearchRow uiRow">
                                    <WorkFlowPlanCriteriaRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                                </li>
                            ))
                        }
                    </ul>
                </UiViewContent>
                <div className="uiROHeader uiSpacer15">
                    <span><SarasTrans value = "Supported conditions"/> </span><br />
                    <span><SarasTrans value = "Sequence Condition: Always or this.NetAmount > [some valid number]"/></span><br />
                    <span><SarasTrans value = "Role Conditions: Role = [id of the role]"/></span><br />
                    <span><SarasTrans value = "User Conditions: Any or User = [id of the user] or Reviewer.Department = Requestor.Department or User = #SELF"/></span>
                </div>
            </FormDialog>
        )
    }
}

export default withView(WorkFlowPlanCriteriaEditor, "WorkFlowTmpl", "")